import type {
    AgentSkill,
    AgentSkillRevision,
} from "@common/schemas/domains/agentSkills/agent-skill.schema";
import { useAgentSkillRevisions } from "@api/agentSkill.api";
import { AgentSkillRevisionList } from "./AgentSkillRevisionList";
import type { useAgentSkillLifecycle } from "./useAgentSkillLifecycle";

interface Props {
    skill: AgentSkill;
    canManage: boolean;
    restore: ReturnType<typeof useAgentSkillLifecycle>["restore"];
    onViewRevision?: (revision: AgentSkillRevision) => void;
    onMoved: (skillId: string) => void;
}

export const AgentSkillVersionsTab = ({
    skill,
    canManage,
    restore,
    onViewRevision,
    onMoved,
}: Props) => {
    const { data: revisions = [], isFetched } = useAgentSkillRevisions(
        skill.id,
    );
    return (
        <AgentSkillRevisionList
            skill={skill}
            revisions={revisions}
            isFetched={isFetched}
            currentRevisionId={skill.currentRevisionId}
            canManage={canManage}
            onView={onViewRevision}
            onRestore={async (revision) => {
                const restored = await restore({
                    skillId: skill.id,
                    revisionId: revision.id,
                    version: revision.version,
                });
                if (restored && restored.id !== skill.id) {
                    onMoved(restored.id);
                }
                return restored;
            }}
        />
    );
};
